<template>
  <b-form @submit.prevent>
    <b-row class="mt-2">
      <b-col
        cols="12"
        class="text-center"
      >
        <p>¿Está seguro de que deseas eliminar?</p>
      </b-col>

      <!-- btn centered actions-->
      <b-col class="text-center mt-2">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          type="reset"
          variant="outline-secondary"
          @click="close"
        >
          Cancelar
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="danger"
          class="ml-4"
          :disabled="loading"
          @click="deleteItem"
        >
          <b-spinner
            v-if="loading"
            small
          />
          {{ loading ? 'Procesando...' : 'Eliminar' }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BForm, BRow, BCol,
  BButton, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    idItem: {
      type: Number,
      default: () => 0,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    deleteItem() {
      this.$emit('delete', this.idItem)
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
